export const selectFirstOption = (dados, form, field) => {
  if ((dados) && (form) && (field) && (dados.length === 1)) {
    form.setFieldsValue({ [field]: dados[0].value });
  }

  return dados;
};